module.exports = __webpack_public_path__ + "img/achievements.cd40396b.svg";